import React, { useState, useCallback, useEffect } from "react";
import DataTable from '../DataTable/DataTable';
import config from "../../Config.json";
import submissionReports from "../../apis/requisitionReports/submissionReport";
import "./requisitionReports.css";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import {
  NotificationManager,
} from "react-notifications";
const stylesSX = {
  odd: {
    background: "#F6F6F6 !important",
  },
  even: {
    background: "#ffffff !important",
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  }),
  waitingText: {
    marginLeft: "5px",
  },
};

const SubmissionReport = (props) => {
  const {
    userType,
    userIdType,
    userRecruitmentpartnerId,
    triggerAction,
    resetTrigger,
    startSelectedDate,
    endSelectedDate,
    trackCandidateSearch,
    initiator,
    trackCandidateSearchEmail,
    additionalFilterData = {
      placementType: "",
      clientName: "",
      divisionId: "",
      interview_date: "",
      start_date: "",
      selected_date: "",
      offer_release_date: "",
      joining_date: "",
      teamId: ""
    }
  } = props;

  const [isSearching, setIsSearching] = useState(true);
  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const [dataResult, setDataResult] = useState([]);

  // Track previous date and filter values to detect changes
  const [prevStartDate, setPrevStartDate] = useState(null);
  const [prevEndDate, setPrevEndDate] = useState(null);
  const [prevFilterData, setPrevFilterData] = useState({});

  // Define columns for the DataTable
  const columns = [
    {
      accessorKey: "recruiter",
      header: "Recruiter",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "submissionDate",
      header: "Submitted Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { created_at } = row.original;
        if (!created_at) return "N/A";
        const date = new Date(created_at);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "displayDate",
      header: "Status Change Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { displayDate } = row.original;
        if (!displayDate) return "N/A";
        const date = new Date(displayDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "name",
      header: "Candidate Name",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "gender",
      header: "Gender",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    ...(trackCandidateSearch ? [] : [{
      accessorKey: "email",
      header: "Email",
      width: "300px",
      enableSorting: true,
      enableFiltering: false,
    },
    ]),
    {
      accessorKey: "client",
      header: "Client",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "clientId",
      header: "Client ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "status",
      header: "Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "reqreferenceId",
      header: "Reference ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "currentStatus",
      header: "Current Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "teamLeader",
      header: "Team Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "recruitmentLeader",
      header: "Recruitment Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    ...(trackCandidateSearch ? [] : [
      {
        accessorKey: "city",
        header: "City",
        width: "180px",
        enableSorting: true,
        enableFiltering: true,
      },
      {
        accessorKey: "state",
        header: "State",
        width: "180px",
        enableSorting: true,
        enableFiltering: true,
      },
      {
        accessorKey: "country",
        header: "Country",
        width: "180px",
        enableSorting: true,
        enableFiltering: true,
      }
    ]),
    {
      accessorKey: "offerDate",
      header: "Offer Released Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { offerDate } = row.original;
        if (!offerDate) return "N/A";
        const date = new Date(offerDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "interviewDate",
      header: "Interview Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { interviewDate } = row.original;
        if (!interviewDate) return "N/A";
        const date = new Date(interviewDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "joiningDate",
      header: "Joining Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { joiningDate } = row.original;
        if (!joiningDate) return "N/A";
        const date = new Date(joiningDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "selectedDate",
      header: "Selected Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { selectedDate } = row.original;
        if (!selectedDate) return "N/A";
        const date = new Date(selectedDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
      cell: ({ row }) => {
        const { startDate } = row.original;
        if (!startDate) return "N/A";
        const date = new Date(startDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "salary",
      header: "Salary",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "placementType",
      header: "Placement Type",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "hourlyMargin",
      header: "Hourly Margin",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "hourlyPayRate",
      header: "Hourly Pay Rate",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "primarySkill",
      header: "Primary Skill",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    ...(trackCandidateSearch ? [] : [
      {
        accessorKey: "phone",
        header: "Phone",
        width: "180px",
        enableSorting: true,
        enableFiltering: true,
      },
      {
        accessorKey: "updated_at",
        header: "Activity Date",
        width: "180px",
        enableSorting: true,
        enableFiltering: true,
      }
    ]),
    {
      accessorKey: "dropOutNotes",
      header: "Drop Out Notes",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    ...(trackCandidateSearch ? [] : [{
      accessorKey: "recruiterLeader",
      header: "Person of Contact",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    }]),
    {
      accessorKey: "source",
      header: "Source",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "resumeStatus",
      header: "External Source",
      width: "180px",
      enableSorting: true,
      enableFiltering: true,
    }
  ];

  // Format date function
  const formatDateOnly = useCallback((dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }, []);

  // Excel export function
  const callApiToGenerateExcel = useCallback(async () => {
    setIsExporting(true);

    const maxSize = config.MAX_SIZE
    const end = Math.ceil(totalResult / maxSize);
    let pageStart = 1;
    let exportArr = [];

    try {
      for (let start = 0; start < end; start++) {
        let payload = {
          orgId: userRecruitmentpartnerId,
          isExport: true,
          page: pageStart,
          size: maxSize,
          formattedDatestart: formatDateOnly(startSelectedDate),
          formattedDateend: formatDateOnly(endSelectedDate),
          userId: userIdType,
          role: userType,
          additionalFilter: {
            placementType: additionalFilterData.placementType || [],
            clientName: additionalFilterData.clientName || [],
            divisionId: additionalFilterData.divisionId || [],
            interview_date: additionalFilterData.interview_date || "",
            joining_date: additionalFilterData.start_date || "",
            start_date: additionalFilterData.selected_date || "",
            selected_date: additionalFilterData.joining_date || "",
            offer_date: additionalFilterData.offer_release_date || "",
            status_list: additionalFilterData.statusList,
            clientJobId: additionalFilterData.clientJobId,
            teamId: additionalFilterData.teamId || []
          },
          page_initiator: "",
        };

        const allDetails = await submissionReports(payload);

        allDetails.data.forEach((element) => {
          let data = {
            Recruiter: element.recruiter,
            "Submitted Date": element.submissionDate,
            "Status Change Date": element.displayDate,
            "Candidate Name": element.name,
            Email: element.email,
            Client: element.client,
            "Client Id": element.clientId,
            Status: element.status,
            Gender: element.gender,
            "Current Status": element.currentStatus,
            "Team Leader": element.teamLeader,
            "Recruitment Leader": element.recruitmentLeader,
            "Reference ID": element.reqreferenceId,
            "Offer Released Date": element.offerDate,
            "Interview Date": element.interviewDate,
            "Start Date": element.startDate,
            "Joining Date": element.joiningDate,
            "Selected Date": element.selectedDate,
            "Salary": element.salary || " ",
            "Placement Type": element.placementType || " ",
            "Hourly Margin": element.hourlyMargin || " ",
            "Hourly Pay Rate": element.hourlyPayRate || " ",
            "Primary Skill": element.primarySkill,
            "Activity Date": element.updated_at,
            "Drop Out Notes": element.dropOutNotes,
            "Person of Contact": element.recruiterLeader,
            Source: element.source,
            "External Sources": element.resumeStatus
          };
          exportArr.push(data);
        });

        pageStart = pageStart + maxSize;
      }

      if (exportArr.length === 0) {
        NotificationManager.error("No data present", "Error", 10000);
        return;
      }


      // Lazy load XLSX only when needed for export
      const { utils, writeFile } = await import("xlsx");
      const wb = utils.book_new();
      const ws = utils.json_to_sheet(exportArr);
      utils.book_append_sheet(wb, ws, "Submission Report");

      writeFile(wb, `SubmissionReport.xlsx`, {
        bookType: "xlsx",
        type: "file",
      });
    } catch (error) {
      console.error("Error exporting:", error);
      NotificationManager.error("Failed to export", "Error", 10000);
    } finally {
      setIsExporting(false);
    }
  }, [
    totalResult,
    userRecruitmentpartnerId,
    startSelectedDate,
    endSelectedDate,
    userIdType,
    userType,
    additionalFilterData,
    formatDateOnly
  ]);

  useEffect(() => {
    if (triggerAction) {
      callApiToGenerateExcel();
      resetTrigger();
    }
  }, [triggerAction, resetTrigger, callApiToGenerateExcel]);

  // Search function without debounce
  const performSearch = useCallback(async (
    userRecruitmentpartnerId,
    pageNumber,
    takeNumberOfResult,
    startSelectedDate,
    endSelectedDate,
    userId,
    additionalFilterData
  ) => {
    let payload = {
      orgId: userRecruitmentpartnerId,
      page: pageNumber,
      size: takeNumberOfResult,
      formattedDatestart: formatDateOnly(startSelectedDate),
      formattedDateend: formatDateOnly(endSelectedDate),
      isExport: false,
      userId: userId,
      role: userType,
      additionalFilter: {
        placementType: additionalFilterData.placementType || [],
        clientName: additionalFilterData.clientName || [],
        divisionId: additionalFilterData.divisionId || [],
        interview_date: additionalFilterData.interview_date || "",
        joining_date: additionalFilterData.start_date || "",
        start_date: additionalFilterData.selected_date || "",
        selected_date: additionalFilterData.joining_date || "",
        offer_date: additionalFilterData.offer_release_date || "",
        status_list: additionalFilterData.statusList,
        clientJobId: additionalFilterData.clientJobId,
        teamId: additionalFilterData.teamId || []
      },
      page_initiator: "",
    };

    if (trackCandidateSearchEmail) {
      payload.candidateEmail = trackCandidateSearchEmail;
    }

    try {
      const search = await submissionReports(payload);

      if (search?.data?.length <= 0) {
        setDataResult([]);
        setTotalResult(0);
      } else {
        setDataResult(search.data);
        if (search.totalCount && search.totalCount[0] && search.totalCount[0].total) {
          setTotalResult(search.totalCount[0].total);
        }
      }
    } catch (error) {
      console.error("Error fetching submission reports:", error);
      setDataResult([]);
      NotificationManager.error("Error fetching data", "Error", 10000);
    } finally {
      setIsSearching(false);
    }
  }, [userType, trackCandidateSearchEmail, formatDateOnly]);

  // Handle page change
  const handlePageChange = (newPage, newPageSize) => {
    setPageNumber(newPage);
    if (newPageSize && newPageSize !== takeNumberOfResult) {
      setTakeNumberOfResult(newPageSize);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setTakeNumberOfResult(newPageSize);
    setPageNumber(1);
  };



  // Check if dates or filters have changed
  useEffect(() => {
    // Check if dates have changed
    const datesChanged =
      prevStartDate !== startSelectedDate ||
      prevEndDate !== endSelectedDate;

    // Check if filters have changed
    const filtersChanged = JSON.stringify(prevFilterData) !== JSON.stringify(additionalFilterData);

    // Reset to page 1 if dates or filters changed
    if (datesChanged || filtersChanged) {
      setPageNumber(1);
      setPrevStartDate(startSelectedDate);
      setPrevEndDate(endSelectedDate);
      setPrevFilterData({ ...additionalFilterData });
    }
  }, [startSelectedDate, endSelectedDate, additionalFilterData, prevStartDate, prevEndDate, prevFilterData]);

  useEffect(() => {
    // Skip invalid dates check if coming from candidateHistory
    if ((!startSelectedDate || !endSelectedDate) && initiator !== "candidateHistory") {
      NotificationManager.error("Please enter a valid date", "Error", 10000);
      return;
    }

    // When any dependency changes, schedule a search.
    setIsSearching(true);
    setDataResult([]);

    const timeoutId = setTimeout(() => {
      performSearch(
        userRecruitmentpartnerId,
        pageNumber,
        takeNumberOfResult,
        startSelectedDate,
        endSelectedDate,
        userIdType,
        additionalFilterData
      );
    }, 1000); // 1000ms debounce delay

    // Cleanup cancels the pending search if dependencies change quickly.
    return () => clearTimeout(timeoutId);
  }, [
    pageNumber,
    takeNumberOfResult,
    startSelectedDate,
    endSelectedDate,
    additionalFilterData,
    userRecruitmentpartnerId,
    userIdType,
    performSearch,
    initiator
  ]);

  return (
    <>
      <Backdrop sx={stylesSX.backdrop} open={isExporting}>
        <CircularProgress color="inherit" />
        <Typography sx={stylesSX.waitingText}>
          {" "}
          Please wait ...
        </Typography>
      </Backdrop>

      <DataTable
        data={dataResult}
        columns={columns}
        isLoading={isSearching}
        totalRecords={totalResult}
        currentPage={pageNumber}
        pageSize={takeNumberOfResult}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        enableFiltering={false}
        enablePagination={true}
        enableSorting={false}
        pageSizeOptions={[10, 20, 50, 100]}
        isServerSide={true}
        className="kendo_reports"
        noDataText="No results found !"
      />
    </>
  );
};

export default SubmissionReport;